import { render, staticRenderFns } from "./OfferItems.vue?vue&type=template&id=3ef80f79&scoped=true&"
import script from "./OfferItems.vue?vue&type=script&lang=js&"
export * from "./OfferItems.vue?vue&type=script&lang=js&"
import style0 from "./OfferItems.vue?vue&type=style&index=0&id=3ef80f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef80f79",
  null
  
)

export default component.exports